import { generateTestId } from "@client-shared";

export const setProductImageLightboxTestId = (identifier: string): string =>
  generateTestId("ProductImageLightbox", identifier);
